import { globalActions } from '../../global-actions';

export const getActionTypes = (actionPrefix) => ({
  SET_CONFIRM_BOTTOM_DIALOG: `${actionPrefix}_SET_CONFIRM_BOTTOM_DIALOG`,
  SET_ACTIVE_BLOCK: `${actionPrefix}_SET_ACTIVE_BLOCK`,
  SET_NOTIFICATION_STATUS: `${actionPrefix}_SET_NOTIFICATION_STATUS`,
  SELECT_TAB: `${actionPrefix}_SELECT_TAB`,
  SET_MODAL_TOOLTIP: `${actionPrefix}_SET_MODAL_TOOLTIP`,
});

export const getActions = (actionPrefix) => ({
  setConfirmBottomDialog: (confirmBottomDialog) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SET_CONFIRM_BOTTOM_DIALOG,
      payload: { confirmBottomDialog },
    });
  },
  setActiveBlock: (blockType) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SET_ACTIVE_BLOCK,
      payload: { blockType },
    });
  },
  setNotificationStatus: (notificationStatus, delay = 0) => {
    setTimeout(() => {
      globalActions.next({
        type: getActionTypes(actionPrefix).SET_NOTIFICATION_STATUS,
        payload: { notificationStatus },
      });
    }, delay);
  },
  selectTab: (selectedTab) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SELECT_TAB,
      payload: { selectedTab },
    });
  },
  setModalTooltip: (modalTooltip) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SET_MODAL_TOOLTIP,
      payload: { modalTooltip },
    });
  },
});
